export default __webpack_public_path__ + "static/streaming-economics-9e223651f36a7194269eca0058c7697f.png";